import { render, staticRenderFns } from "./account-plan-container.vue?vue&type=template&id=05bba678"
import script from "./account-plan-container.vue?vue&type=script&lang=js"
export * from "./account-plan-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports